<template>
  <div>
    <main-layout :showSideBar="!issidebar">
      <div class="content-wrap clearing" v-loading="loadingAccount">
        <div class="f-clearseachbox">
          <el-form ref="searchForm" size="small" label-width="90px" :inline="true">
            <el-form-item label="清算日期">
              <datePicker :defaultValue="createDateDefaultValue" :reset="resetTog" v-model="date" />
            </el-form-item>
            <el-form-item label="支付通道">
              <el-select clearable v-model="payChannel" placeholder="请选择" class>
                <el-option
                  v-for="item in PAY_CHANNEL"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="seachForm" type="primary">搜索</el-button>
              <el-button @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
          <div v-if="isClearingExport" class="f-clearfix">
            <el-button size="small" @click="exports" type="primary">
              批量导出
            </el-button>
          </div>
        </div>
        <div class="tips" v-show="showTips">
          随行付账户余额
          <em>{{ account.balance ? account.balance : '--' }}</em
          >元，预留结算金额<em> {{ account.reserved ? account.reserved : '--' }} </em>元；
          <i class="el-icon-refresh" @click="refreshAccount"></i>
        </div>

        <cleartable
          :table-data="tableData"
          v-loading="loadingtable"
          @returngoods="seach"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        ></cleartable>
        <Paging
          layout="prev, pager, next, total, sizes, jumper"
          v-if="aCount > 10"
          :currentPage="pagObj"
          :total="aCount"
          :handleCurrentChange="handleCurrentChange"
          :handleSizeChange="handleSizeChange"
        ></Paging>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/views/layout/mainlayout';
import cleartable from './cleartable';
import { _dateFormat, getNearestWeekDates } from '@/utils/times';
import Paging from '@components/public/paging';
import datePicker from '@components/public/datePicker';
import axiosRequestNew from '@api/axiosRequestNew';
import { PAY_CHANNEL } from './constant';

export default {
  name: 'Clearing',
  components: {
    MainLayout,
    cleartable,
    datePicker,
    Paging,
  },
  data() {
    return {
      tableData: [],
      aCount: 0,
      oldtimer: '',
      resetTog: false,
      createDateDefaultValue: getNearestWeekDates(29),
      date: '',
      issidebar: false,
      loadingtable: false,
      isClearingExport: true,
      payChannel: '',
      pagObj: {
        currentPage: 1,
        pageSize: 10,
      },
      PAY_CHANNEL,
      showTips: false, ////随行付 账户余额 预留资金 显示
      loadingAccount: false,
      account: {}, //随行付 账户余额 预留资金
    };
  },
  mounted() {
    const registerType = sessionStorage.getItem('registerType');
    const payClearingExport = sessionStorage.getItem('payClearingExport'); // 导出清算查询结果
    if (registerType && registerType == '0') {
      payClearingExport ? '' : (this.isClearingExport = false);
    }
    this.$nextTick(() => {
      this.seach();
    });
    if (registerType) {
      const payState = sessionStorage.getItem('payState');
      if (payState && payState == '0') {
        this.isdb = true;
        this.issidebar = true;
      }
    }

    this.refreshAccount();
  },
  methods: {
    validateSearchForm() {
      const starttime = this.date[0];
      const endtime = this.date[1];
      if (starttime && endtime) {
        if (this.getDays(starttime, endtime) > 119) {
          this.$message.error('时间跨度不得超过120天！');
          return false;
        }
      }
      return true;
    },
    exports() {
      if (!this.validateSearchForm()) {
        return;
      }
      const searchObj = this.getSearchFormObj();
      const params = [];
      for (const key in searchObj) {
        params.push(`${key}=${searchObj[key] || ''}`);
      }
      location.href = `//${
        window.location.host
      }/juheCustomer/export/queryClearingExport.do?${params.join('&')}`;
    },
    getDays(strDateStart, strDateEnd) {
      const strSeparator = '-'; // 日期分隔符
      let oDate1;
      let oDate2;
      let iDays;
      oDate1 = strDateStart.split(strSeparator);
      oDate2 = strDateEnd.split(strSeparator);
      const strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2]);
      const strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2]);
      iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24); // 把相差的毫秒数转换为天数
      return iDays;
    },
    getSearchFormObj() {
      const searchFormObj = {};
      if (Array.isArray(this.date) && this.date.length > 0) {
        searchFormObj.startDate = this.date[0];
        searchFormObj.endDate = this.date[1];
      }
      if (this.payChannel) {
        searchFormObj.payChannel = this.payChannel;
      }
      const formKeys = Object.keys(searchFormObj);
      formKeys.forEach((key) => {
        if (searchFormObj[key] === '' || searchFormObj === undefined) {
          delete searchFormObj[key];
        }
      });
      return searchFormObj;
    },
    seachForm() {
      this.pagObj.currentPage = 1;
      this.seach();
    },
    seach() {
      if (!this.validateSearchForm()) {
        return;
      }
      const searchFormData = this.getSearchFormObj();
      axiosRequestNew
        .post('query/queryCustomerClearingList.do', {
          ...searchFormData,
          pageSize: this.pagObj.pageSize,
          currentPage: this.pagObj.currentPage,
        })
        .then((res) => {
          if (res.code == '200') {
            const { data } = res;
            this.tableData = data.result;
            this.aCount = data.count;
          }
        });
    },
    handleSizeChange(val) {
      this.pagObj.pageSize = val;
      this.pagObj.currentPage = 1;
      this.seach();
    },
    handleCurrentChange(val) {
      this.pagObj.currentPage = val;
      this.seach();
    },
    reset() {
      this.resetTog = !this.resetTog;
      this.date = [
        _dateFormat(new Date(new Date().getTime() - 29 * 24 * 60 * 60 * 1000), 'yy-MM-dd'),
        _dateFormat(new Date(), 'yy-MM-dd'),
      ];
      this.payChannel = '';
      this.seach();
    },
    // 获取随行付账户余额、预留资金
    refreshAccount(e) {
      // 手动点击的时候 加loading
      if (e) {
        this.loadingAccount = true;
      }

      axiosRequestNew
        .post(
          'clearing/queryAccountAmount.do',
          {},
          {
            headers: {
              disableMessage: true,
            },
          },
        )
        .then(({ code, data }) => {
          if (code == '200' && data) {
            const { balance, reserved } = data || {};
            this.showTips = true;
            this.account = { balance, reserved };
          } else {
            this.showTips = false;
          }
        })
        .finally(() => {
          this.loadingAccount = false;
        });
    },
  },
};
</script>

<style lang="scss">
.tips {
  font-size: 14px;
  margin-top: 16px;
  background: #fff7eb;
  padding: 7px 16px;

  span {
    color: rgba(0, 0, 0, 0.65);
    letter-spacing: 0;
  }

  em {
    font-style: inherit;
    font-family: PingFangSC-Semibold;
    color: #d0021b;
    letter-spacing: 0;
  }

  .el-icon-refresh {
    font-size: 16px;
    color: #409eff;
    cursor: pointer;
  }
}
</style>
